import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
          <i className="ri-ghost-line text-4xl text-foreground-400"></i>
        </div>
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">
          页面不存在
        </h2>
        <p className="mt-2 text-sm text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base text-foreground-500">
          抱歉，您访问的页面不存在或已被移除
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-home-line text-sm"></i>
          </div>
          返回首页
        </Link>
      </div>
    </div>
  );
}